export default "__VITE_ASSET__C_xNm2eK__"